import { AbstractControl, ValidationErrors } from '@angular/forms';

const PHONE_PATTERN = /^\+?[\d\s\-().]+$/;

/**
 * Lenient phone-number check: digits with the usual separators (space, dash, dot, brackets) and
 * an optional leading +, holding 8–15 digits (15 = E.164 maximum). Catches typos and free text
 * without rejecting any real national or international notation.
 */
export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value == null ? '' : String(control.value).trim();

  if (!value) {
    // no value = valid; use required for mandatory fields
    return null;
  }

  const digits = value.replace(/\D/g, '').length;
  return PHONE_PATTERN.test(value) && digits >= 8 && digits <= 15 ? null : { invalidPhone: true };
}
